var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.template === "orders"
      ? _c("div", { staticClass: "simple__block" }, [
          _c("h3", { staticClass: "h5" }, [
            _vm._v(_vm._s(_vm.get_translation_constant("text_attached_files"))),
          ]),
          _vm._v(" "),
          _c("table", { staticClass: "table table__files" }, [
            _c("thead", [
              _c("tr", [
                _c("th", [
                  _vm._v(
                    _vm._s(_vm.get_translation_constant("text_file_format"))
                  ),
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(
                    _vm._s(_vm.get_translation_constant("text_file_name"))
                  ),
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(_vm._s(_vm.get_translation_constant("text_size"))),
                ]),
                _vm._v(" "),
                _c("th"),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _vm._l(_vm.filesFromServer, function (file, idx) {
                  return _c("tr", [
                    _c("td", [
                      _c(
                        "div",
                        {
                          staticClass: "file",
                          class: _vm.getServerFileExtension(file),
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.getServerFileExtension(file).toUpperCase()
                              ) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "a",
                        {
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.downloadServerFileFile(file)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.getServerFileName(file)))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "file-size d-lg-none" }, [
                        _vm._v(_vm._s(_vm.getServerFileSize(file))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.getServerFileSize(file)))]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "table__actions d-flex justify-content-end",
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "javascript:void(0)",
                                title: "Remove",
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.removeServerFile(idx)
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M15.2 16.31l.52-10.47h.73c.3 0 .55-.24.55-.53 0-.3-.24-.55-.55-.55h-3.22V3.7c0-1.02-.72-1.69-1.86-1.69H8.61c-1.14 0-1.84.67-1.84 1.69v1.07H3.55c-.3 0-.55.25-.55.55 0 .3.26.53.55.53h.74l.51 10.48c.05 1.03.75 1.68 1.82 1.68h6.77c1.06 0 1.76-.66 1.82-1.69zM7.96 3.76c0-.4.3-.7.75-.7h2.6c.44 0 .75.3.75.7v1h-4.1v-1zM6.73 16.93a.75.75 0 01-.77-.73L5.44 5.84h9.1l-.5 10.36a.74.74 0 01-.76.73H6.73zm5.46-1.26c.25 0 .43-.2.44-.47l.22-7.56c0-.27-.18-.47-.44-.47-.22 0-.42.2-.42.46l-.23 7.57c0 .26.18.47.43.47zm-4.38 0c.26 0 .44-.21.43-.47l-.22-7.57c0-.25-.2-.46-.43-.46-.26 0-.44.2-.43.47l.23 7.56c0 .27.18.47.42.47zm2.64-.47V7.63c0-.25-.2-.46-.44-.46-.25 0-.45.2-.45.46v7.57c0 .26.2.47.45.47.23 0 .44-.21.44-.47z",
                                      fill: "#515154",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ])
                }),
                _vm._v(" "),
                _vm._l(_vm.files, function (file, idx) {
                  return _c("tr", [
                    _c("td", [
                      _c(
                        "div",
                        { staticClass: "file", class: _vm.getExtension(file) },
                        [_vm._v(_vm._s(_vm.getExtension(file).toUpperCase()))]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "a",
                        {
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.downloadFile(file)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.getName(file)))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "file-size d-lg-none" }, [
                        _vm._v(_vm._s(_vm.getSize(file))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.getSize(file)))]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "table__actions d-flex justify-content-end",
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "javascript:void(0)",
                                title: "Remove",
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.remove(idx)
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M15.2 16.31l.52-10.47h.73c.3 0 .55-.24.55-.53 0-.3-.24-.55-.55-.55h-3.22V3.7c0-1.02-.72-1.69-1.86-1.69H8.61c-1.14 0-1.84.67-1.84 1.69v1.07H3.55c-.3 0-.55.25-.55.55 0 .3.26.53.55.53h.74l.51 10.48c.05 1.03.75 1.68 1.82 1.68h6.77c1.06 0 1.76-.66 1.82-1.69zM7.96 3.76c0-.4.3-.7.75-.7h2.6c.44 0 .75.3.75.7v1h-4.1v-1zM6.73 16.93a.75.75 0 01-.77-.73L5.44 5.84h9.1l-.5 10.36a.74.74 0 01-.76.73H6.73zm5.46-1.26c.25 0 .43-.2.44-.47l.22-7.56c0-.27-.18-.47-.44-.47-.22 0-.42.2-.42.46l-.23 7.57c0 .26.18.47.43.47zm-4.38 0c.26 0 .44-.21.43-.47l-.22-7.57c0-.25-.2-.46-.43-.46-.26 0-.44.2-.43.47l.23 7.56c0 .27.18.47.42.47zm2.64-.47V7.63c0-.25-.2-.46-.44-.46-.25 0-.45.2-.45.46v7.57c0 .26.2.47.45.47.23 0 .44-.21.44-.47z",
                                      fill: "#515154",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ])
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-md-flex justify-content-end" }, [
            _c(
              "a",
              {
                staticClass: "btn btn__large btn__blue_border d-block",
                on: {
                  click: function ($event) {
                    return _vm.$refs.input.click()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.get_translation_constant("text_add_file")))]
            ),
            _vm._v(" "),
            _vm.multiple
              ? _c("input", {
                  ref: "input",
                  staticStyle: { display: "none" },
                  attrs: {
                    type: "file",
                    multiple: _vm.multiple,
                    placeholder: _vm.get_translation_constant("text_add_file"),
                  },
                  on: { input: _vm.updateFiles, click: _vm.checkFiles },
                })
              : _vm._e(),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.template === "arrived"
      ? _c("div", { staticClass: "simple__block block-upload-files" }, [
          _c(
            "a",
            {
              staticClass:
                "btn btn__large btn__blue_border d-block input-upload",
              on: {
                click: function ($event) {
                  return _vm.$refs.input.click()
                },
              },
            },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.get_translation_constant(
                      "text_upload_payment_confirmation_files"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c("span", {
                staticClass: "file-extension",
                domProps: { innerHTML: _vm._s(_vm.allowedMimeTypeList) },
              }),
            ]
          ),
          _vm._v(" "),
          _vm.multiple
            ? _c("input", {
                ref: "input",
                staticStyle: { display: "none" },
                attrs: {
                  type: "file",
                  multiple: _vm.multiple,
                  placeholder: _vm.get_translation_constant("text_add_file"),
                },
                on: { input: _vm.updateFiles, click: _vm.checkFiles },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("table", { staticClass: "table table__files" }, [
            _c(
              "tbody",
              [
                _vm._l(_vm.filesFromServer, function (file, idx) {
                  return _c("tr", [
                    _c("td", [
                      _c(
                        "div",
                        {
                          staticClass: "file",
                          class: _vm.getServerFileExtension(file),
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.getServerFileExtension(file).toUpperCase()
                              ) +
                              "\n                        "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "a",
                        {
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.downloadServerFileFile(file)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.getServerFileName(file)))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "file-size d-lg-none" }, [
                        _vm._v(_vm._s(_vm.getServerFileSize(file))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.getServerFileSize(file)))]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "table__actions d-flex justify-content-end",
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "javascript:void(0)",
                                title: "Remove",
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.removeServerFile(idx)
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M15.2 16.31l.52-10.47h.73c.3 0 .55-.24.55-.53 0-.3-.24-.55-.55-.55h-3.22V3.7c0-1.02-.72-1.69-1.86-1.69H8.61c-1.14 0-1.84.67-1.84 1.69v1.07H3.55c-.3 0-.55.25-.55.55 0 .3.26.53.55.53h.74l.51 10.48c.05 1.03.75 1.68 1.82 1.68h6.77c1.06 0 1.76-.66 1.82-1.69zM7.96 3.76c0-.4.3-.7.75-.7h2.6c.44 0 .75.3.75.7v1h-4.1v-1zM6.73 16.93a.75.75 0 01-.77-.73L5.44 5.84h9.1l-.5 10.36a.74.74 0 01-.76.73H6.73zm5.46-1.26c.25 0 .43-.2.44-.47l.22-7.56c0-.27-.18-.47-.44-.47-.22 0-.42.2-.42.46l-.23 7.57c0 .26.18.47.43.47zm-4.38 0c.26 0 .44-.21.43-.47l-.22-7.57c0-.25-.2-.46-.43-.46-.26 0-.44.2-.43.47l.23 7.56c0 .27.18.47.42.47zm2.64-.47V7.63c0-.25-.2-.46-.44-.46-.25 0-.45.2-.45.46v7.57c0 .26.2.47.45.47.23 0 .44-.21.44-.47z",
                                      fill: "#515154",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ])
                }),
                _vm._v(" "),
                _vm._l(_vm.files, function (file, idx) {
                  return _c("tr", [
                    _c("td", [
                      _c(
                        "div",
                        { staticClass: "file", class: _vm.getExtension(file) },
                        [_vm._v(_vm._s(_vm.getExtension(file).toUpperCase()))]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "a",
                        {
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.downloadFile(file)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.getName(file)))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "file-size d-lg-none" }, [
                        _vm._v(_vm._s(_vm.getSize(file))),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.getSize(file)))]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "table__actions d-flex justify-content-end",
                        },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: "javascript:void(0)",
                                title: "Remove",
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.remove(idx)
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M15.2 16.31l.52-10.47h.73c.3 0 .55-.24.55-.53 0-.3-.24-.55-.55-.55h-3.22V3.7c0-1.02-.72-1.69-1.86-1.69H8.61c-1.14 0-1.84.67-1.84 1.69v1.07H3.55c-.3 0-.55.25-.55.55 0 .3.26.53.55.53h.74l.51 10.48c.05 1.03.75 1.68 1.82 1.68h6.77c1.06 0 1.76-.66 1.82-1.69zM7.96 3.76c0-.4.3-.7.75-.7h2.6c.44 0 .75.3.75.7v1h-4.1v-1zM6.73 16.93a.75.75 0 01-.77-.73L5.44 5.84h9.1l-.5 10.36a.74.74 0 01-.76.73H6.73zm5.46-1.26c.25 0 .43-.2.44-.47l.22-7.56c0-.27-.18-.47-.44-.47-.22 0-.42.2-.42.46l-.23 7.57c0 .26.18.47.43.47zm-4.38 0c.26 0 .44-.21.43-.47l-.22-7.57c0-.25-.2-.46-.43-.46-.26 0-.44.2-.43.47l.23 7.56c0 .27.18.47.42.47zm2.64-.47V7.63c0-.25-.2-.46-.44-.46-.25 0-.45.2-.45.46v7.57c0 .26.2.47.45.47.23 0 .44-.21.44-.47z",
                                      fill: "#515154",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ])
                }),
              ],
              2
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.template === "preview-photo" && _vm.filesFromServer.length
      ? _c("div", { staticClass: "simple__block" }, [
          _c("h3", { staticClass: "h5" }, [
            _vm._v(
              _vm._s(
                _vm.get_translation_constant("text_preview_service_pictures")
              )
            ),
          ]),
          _vm._v(" "),
          _c("table", { staticClass: "table table__files" }, [
            _c("thead", [
              _c("tr", [
                _c("th", [
                  _vm._v(
                    _vm._s(_vm.get_translation_constant("text_file_format"))
                  ),
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(
                    _vm._s(_vm.get_translation_constant("text_file_name"))
                  ),
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(_vm._s(_vm.get_translation_constant("text_size"))),
                ]),
                _vm._v(" "),
                _c("th"),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.filesFromServer, function (file, idx) {
                return _c("tr", [
                  _c("td", [
                    _c(
                      "div",
                      {
                        staticClass: "file",
                        class: _vm.getServerFileExtension(file),
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.getServerFileExtension(file).toUpperCase()
                            ) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "a",
                      {
                        attrs: { href: "javascript:void(0)" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.downloadServerFileFile(file)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.getServerFileName(file)))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "file-size d-lg-none" }, [
                      _vm._v(_vm._s(_vm.getServerFileSize(file))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("td", [_vm._v(_vm._s(_vm.getServerFileSize(file)))]),
                  _vm._v(" "),
                  _c("td"),
                ])
              }),
              0
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }